import { SET_SOURCE_INTEGRATIONS_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

export default createSettingsReducer(SET_SOURCE_INTEGRATIONS_SETTINGS, {
  searchTerm: ''
})
